/*
 *  Author: DL
 *  Date: 2020-12-03 09:53:55
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-04 18:34:57
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

import React from 'react';
import Redirect from 'umi/redirect';

export default () => <Redirect to="/home" />;
